"use client";
import useIsClient from "@/hooks/useIsClient";
import Script from "next/script";

const ScriptInject: React.FC<{ id: string | number; script: string }> = ({
  script,
  id,
}) => {
  const isClient = useIsClient();
  if (!isClient) return;
  return (
    <Script
      id={`html-block-custom-script-${id}`}
      dangerouslySetInnerHTML={{ __html: script }}
    />
  );
};

export default ScriptInject;
